import React from 'react';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import { applyMiddleware, createStore, compose } from 'redux';
import { persistStore } from 'redux-persist';
import reducers from 'store/reducer';
import { createAxios } from 'config/axios';

const createConfigureStore = async () => {
  const store = createStore(reducers, compose(applyMiddleware(thunk, promise)));

  const persist = await persistStore(store);
  createAxios(store);
  return { store, persist };
};

export function useStore() {
  const alive = React.useRef(true);

  const [store, setStore] = React.useState();
  const [persist, setPersist] = React.useState();

  React.useEffect(() => {
    const configStore = async () => {
      try {
        const { store, persist } = await createConfigureStore();

        if (alive.current) {
          setStore(store);
          setPersist(persist);
        }
      } catch (error) {
        // handle error
      }
    };

    configStore();
    setTimeout(() => {
      return () => {
        alive.current = false;
      };
    }, 3000);
  }, []);

  /**
   * Check the store created successfully
   * @type {boolean}
   */
  const isReady = React.useMemo(() => {
    return store !== null && persist !== null;
  }, [store, persist]);

  return { store, persist, isReady };
}
export default createConfigureStore;
